import App from "@frog/source/models/App.js"
import Audio from "@frog/source/utility/Audio.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

const briefings = [
    require("@frog/source/assets/images/book-tactics/briefings/mission briefing 1.png"),
    require("@frog/source/assets/images/book-tactics/briefings/mission briefing 2.png"),
    require("@frog/source/assets/images/book-tactics/briefings/mission briefing 3.png"),
    require("@frog/source/assets/images/book-tactics/briefings/mission briefing 4.png"),
    require("@frog/source/assets/images/book-tactics/briefings/mission briefing 5.png"),
    require("@frog/source/assets/images/book-tactics/briefings/mission briefing 6.png"),
    require("@frog/source/assets/images/book-tactics/briefings/mission briefing 7.png"),
    require("@frog/source/assets/images/book-tactics/briefings/mission briefing 8.png"),
    require("@frog/source/assets/images/book-tactics/briefings/mission briefing 9.png"),
]

export default {
    "slug": "book",
    "title": "LD58",
    "introduction": "a game for Ludum Dare 58",
    "firstChapterKey": "1",
    "player": require("./player.js").default,
    "chapters": {
        "1": require("./1").default,
        "2": require("./2").default,
        "3": require("./3").default,
        "4": require("./4").default,
        "5": require("./5").default,
        "6": require("./6").default,
        "7": require("./7").default,
        "8": require("./8").default,
        "9": require("./9").default,
        "X": require("./X").default,
    },
    "overworld": {
        "image": () => {
            return briefings[App.lastChapterSlug || 0]
        },
        "locations": {
            "1": {
                "key": "1",
                "chapterKey": "1",
                "position": {"x": 1, "y": 1},
                "isDisplayed": true,
                "isReachable": true,
                "text": "ch1",
            },
            "2": {
                "key": "2",
                "chapterKey": "2",
                "position": {"x": 1, "y": 2},
                "isDisplayed": true,
                "isReachable": false,
                "text": "ch2",
            },
            "3": {
                "key": "3",
                "chapterKey": "3",
                "position": {"x": 1, "y": 3},
                "isDisplayed": true,
                "isReachable": false,
                "text": "ch3",
            },
            "4": {
                "key": "4",
                "chapterKey": "4",
                "position": {"x": 1, "y": 4},
                "isDisplayed": true,
                "isReachable": false,
                "text": "ch4",
            },
            "5": {
                "key": "5",
                "chapterKey": "5",
                "position": {"x": 1, "y": 5},
                "isDisplayed": true,
                "isReachable": false,
                "text": "ch5",
            },
            "6": {
                "key": "6",
                "chapterKey": "6",
                "position": {"x": 2, "y": 1},
                "isDisplayed": true,
                "isReachable": false,
                "text": "ch6",
            },
            "7": {
                "key": "7",
                "chapterKey": "7",
                "position": {"x": 2, "y": 2},
                "isDisplayed": true,
                "isReachable": false,
                "text": "ch7",
            },
            "8": {
                "key": "8",
                "chapterKey": "8",
                "position": {"x": 2, "y": 3},
                "isDisplayed": true,
                "isReachable": false,
                "text": "ch8",
            },
            "9": {
                "key": "9",
                "chapterKey": "9",
                "position": {"x": 2, "y": 4},
                "isDisplayed": true,
                "isReachable": false,
                "text": "ch9",
            },
            "X": {
                "key": "X",
                "chapterKey": "X",
                "position": {"x": 2, "y": 5},
                "isDisplayed": true,
                "isReachable": false,
                "text": "chX",
            },
        },
        "hasBook": false,
        "bookFlags": {
            "contracttableofcontents": false,
            "missionoverview": false,
            "nondisclosureproceedures": false,
            "undead": false,
            "eyebeast": false,
            "werewolf": false,
            "manmoth": false,
            "vampire": false,
            "angel": false,
            "ooze": false,
            "ghost": false,
            "demon": false,
            "mimic": false,
            "unicorn": false,
            "ratking": false,
            "shadowbeast": false,
        }
    },
    "configuration": {
        "darkness": "none",
        // "isRenderingEncounters": true,
        // "isRenderingSpots": true,
    },
    "credits": [
        "Andrew Goodenough",
        "Anna Arkhipova",
        // TODO: Add other Jammers!!
    ],
    "analytics": {
        "gameKey": "6369029c42a56108ccc487bccc312434",
        "secretKey": "ec976b9325402eaee722c2dddbce241392a86bd8",
    },
    "openingEvents": function() {
        return [
            {"func": () => Navigation.go("/games/book/overworld")},
            PlotSteps.BlackoutDialogue(`
                Welcome to your new job!
                Please sign this NDA
            `),
            {
                "type": "StartDialogue",
                "duration": Infinity,
                "isUnskippable": true,
                "deltastages": [
                    {
                        "mark": 0,
                        "dialogue": {
                            "type": "Contract",
                            "data": {},
                        }
                    }
                ]
            },
        ]
    },
    "audio": {
        "Ambience": {
            "volume": 0.2,
            "label": "ambience",
            "kill": {"label": "ambience"},
            "loop": true,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/ambience-dungeon.mp3")),
        },
        "Dialogue:Blip": {
            "volume": 0.1,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/select-move1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/select-move2.mp3")),
            ],
        },
        "Selection:Start": {
            "volume": 0.3,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/select-start.mp3")),
        },
        "Selection:Finish": {
            "volume": 0.3,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/select-finish.mp3")),
        },
        "Selection:Cancel": {
            "volume": 0.3,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/select-cancel.mp3")),
        },
        "Selection:Move": {
            "volume": 0.3,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/select-move1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/select-move2.mp3")),
            ],
        },
        "EndTurn": {
            "volume": 0.5,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/endturn.mp3")),
        },
        "UndoAction": {
            "volume": 0.3,
            "type": "once:rotation",
            "audio": [
                // new Audio(require("@frog/source/assets/audio/horror-tactics/undo1.mp3")),
                // new Audio(require("@frog/source/assets/audio/horror-tactics/undo2.mp3")),
                // new Audio(require("@frog/source/assets/audio/horror-tactics/undo3.mp3")),
                // new Audio(require("@frog/source/assets/audio/horror-tactics/undo-1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/undo-2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/undo-3.mp3")),
            ]
        },
        "Unit:Attack:Melee": {
            "volume": 0,
        },
        "Unit:Attack:FinalHit": {
            "volume": 0,
        },
        "Unit:Attack:NoDamage": {
            "volume": 0,
        },
        "Unit:Attack:Monster": {
            "volume": 0.4,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-blood-1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-blood-2.mp3")),
            ]
        },
        "Unit:Pull": {
            "volume": 0.4,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull3.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull4.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull5.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull6.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull7.mp3")),
            ]
        },
        "Unit:Death": {
            "volume": 0.4,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/death1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/death2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/death3.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/death4.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/death5.mp3")),
            ]
        },
        "Unit:Death:Knell": {
            "volume": 0.5,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/death-knell.mp3"))
        },
        "Music:1": {
            "key": "Music:1",
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "loop": true,
            "audio": new Audio(require("@frog/source/assets/audio/book-tactics/book1.mp3")),
        },
        "Music:2": {
            "key": "Music:2",
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "loop": true,
            "audio": new Audio(require("@frog/source/assets/audio/book-tactics/book2.mp3")),
        },
        "Music:4": {
            "key": "Music:4",
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "loop": false,
            "audio": new Audio(require("@frog/source/assets/audio/book-tactics/book4.mp3")),
        },
        "Music:5": {
            "key": "Music:5",
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "loop": true,
            "audio": new Audio(require("@frog/source/assets/audio/book-tactics/book5.mp3")),
        },
        "Stinger:Failure": {
            "volume": 0.33,
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/book-tactics/loss3.wav")),
        },
        "Stinger:Success": {
            "volume": 0.33,
            "kill": {"label": "music"},
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/book-tactics/victory.wav")),
                new Audio(require("@frog/source/assets/audio/book-tactics/victory2.wav")),
                new Audio(require("@frog/source/assets/audio/book-tactics/victory3.wav")),
            ]
        },
        "Stinger:Victory:Qualified": {
            "volume": 0.33,
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/book-tactics/qualified-success.wav")),
        },
    },
}
